<template>
  <v-container fluid class="brand-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-tabs
          color="primary"
        >
          <v-tabs-slider></v-tabs-slider>

          <v-tab
            :href="`#tab-account`"
            class="mr-5"
          >
            <v-icon class="mr-3">mdi-heart-box</v-icon>
            Brand
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-photo`"
          >
            <v-icon class="mr-3">mdi-camera</v-icon>
            Photo
          </v-tab>

          <v-tab
            class="mr-5"
            :href="`#tab-photos`"
          >
            <v-icon class="mr-3">mdi-camera</v-icon>
            Display Photos
          </v-tab>
          <v-tab></v-tab>
          <v-tab></v-tab>
          <v-tab-item
            :value="'tab-account'"
          >
            <v-card
              elevation="0"
              flat
              tile
            >
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">Edit Brand</p>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="onChangeBrand($event, 'brandcode')"
                        v-bind:value="initvalue.brandcode"
                        placeholder="Brand Code"
                        persistent-hint
                        single-line hint="Enter the brand code">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="onChangeBrand($event, 'brandname')"
                        v-bind:value="initvalue.brandname"
                        placeholder="Brand Name"
                        persistent-hint
                        single-line hint="Enter the brand name">
                      </v-text-field>
                      <v-switch
                          color="primary"
                          v-on:change="onChangeBrand($event, 'brandstatus')"
                          v-bind:label="initvalue.brandstatus"
                          v-model="initvalue.brandstatus"
                          value="Active"
                      ></v-switch>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="5">
                    <v-form>
                      <p class="text-h5">&nbsp;</p>
                      <v-select
                        class="mb-4"
                        :items=items
                        :value="initvalue.brandtype"
                        outlined
                        dense
                        v-on:change="onChangeBrand($event, 'brandtype')"
                        placeholder="Type"
                        persistent-hint
                        single-line hint="Please choose the brand type">
                      </v-select>
                      <v-select
                        class="mb-4"
                        :items="itemcategories.map(x => {
                            return {text: x.itemcategoryname, value: x._id};
                          })"
                        :value="initvalue.brandcategories"
                        outlined
                        dense
                        multiple
                        v-on:change="onChangeBrand($event, 'brandcategories')"
                        placeholder="Brand Categories"
                        persistent-hint
                        single-line hint="Enter brand categories">
                      </v-select>

                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="8">
                    <div class="d-flex justify-center">
                        <v-btn
                            to="/brand/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editBrand()">
                            Save
                          </v-btn>
                      </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item
              :value="'tab-photo'"
          >
            <v-card
                flat
                tile
            >
              <v-card-text>

                <v-row justify="center">
                  <v-col cols="12" md="6">
                    <v-form>
                      <p class="text-h5">Upload Photo</p>
                        <v-file-input label="File input" v-on:change="onFileChange" accept="image/*" />
                        <v-img contain max-height="150" max-width="250" :src="imageurl" />
                        <v-spacer min-height="20">&nbsp;</v-spacer>
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/brand/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editPhoto()">
                            Save
                          </v-btn>
                      </div>
                    </v-form>
                  </v-col>
                </v-row>

              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item
              :value="'tab-photos'"
          >
            <v-card
                flat
                tile
            >
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="6">
                  <v-form>
                    <p class="text-h5">Upload Photo</p>
                    <div class="d-flex justify-center">
                    <v-file-input label="Upload Image" clearable v-model="filename" v-on:change="onUploadChange" accept="image/*" />
                          <v-btn
                            class="button-shadow"
                            color="primary"
                            @click="uploadPhotos()">
                            Upload
                          </v-btn>
                    </div>
                  </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="6">
                  <v-row>
                  <v-col md="4" v-for="image in images" :key="image">
                      <div class="text-center">
                        <v-img contain max-height="150" max-width="250" :src="image" />
                          <v-btn
                            class="mx-2"
                            fab
                            dark
                            x-small
                            color="primary"
                            @click="deletePhotos(image)"
                          >
                            <v-icon dark>
                              mdi-close
                            </v-icon>
                          </v-btn>
                      </div>
                  </v-col>
                  </v-row>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="6">
                      <div class="d-flex justify-center">
                        <v-spacer></v-spacer>
                        <v-btn
                            to="/brand/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Done
                        </v-btn>
                      </div>
                  </v-col>
                </v-row>
                <v-spacer min-height="20">&nbsp;</v-spacer>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import router from '@/Routes';
import {mapActions, mapState} from "vuex";

export default {
  data () {
    return {
      brand: {},
      detail: {},
      photo: {},
      
      filename: null,
      initvalue: {},
      imageurl: undefined,
      images: [],
      upload: {},
      items: ['Brand', 'Other Brand'],
      switch1: false,
      switch2: false,
    }
  },
  methods: {
    ...mapActions('Brand', ['updateBrandRequest', 'updateBrandImageRequest','getBrandsRequest']),
    ...mapActions('ItemCategory', ['getItemCategoriesRequest']),
    editBrand() {
      this.brand._id = this.initvalue._id;
      this.updateBrandRequest(this.brand);
      this.getBrandsRequest();
      router.push('/brand/list');
    },
    editPhoto() {
      this.photo._id = this.initvalue._id;
      this.updateBrandImageRequest(this.photo);
      this.getBrandsRequest();
      router.push('/brand/list');
    },
    onChangeBrand(value, field){
      this.brand[field] = value;
      console.log(this.brand)
    },
    createImage(file) {
      const reader = new FileReader();

      reader.onload = e => {
        this.imageurl = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    onFileChange(file) {
      if (!file) {return;}
      this.photo.brandimage = file;
      this.photo.imagename = file.name;
      this.createImage(file);
    },
    onUploadChange(file) {
      if (!file) {return;}
      this.upload.brandimage = file;
      this.upload.imagename = file.name;
    },
  },
  computed: {
    ...mapState('Brand', ['isReceiving']),
    ...mapState('ItemCategory', ['itemcategories'])
  },
  async created () {
    this.initvalue = this.$route.params;
    this.imageurl = this.initvalue.brandimage;
    if(!this.initvalue._id) this.$router.push({ name: 'BrandList' });
    if(this.itemcategories.length==0) await this.getItemCategoriesRequest();
  },
}
</script>

<style src="./Edit.scss" lang="scss"></style>
